import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "bluetoothFilled"
const BluetoothFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M11.062 2.703C11.062 1.7 12.274 1.199 12.982 1.907L18.2 7.125 13.325 12 18.2 16.875 12.983 22.093C12.274 22.8 11.063 22.3 11.063 21.297V14.263L6.662 18.663 5.337 17.337 10.674 12 5.337 6.663 6.663 5.337 11.063 9.737zM12.937 19.487 15.55 16.875 12.937 14.263zM12.937 9.737 15.55 7.125 12.937 4.513z" />
        </svg>
      }
    </span>
  )
}
export default BluetoothFilledIcon
